import { useEffect, useState } from 'react'
import { NATIVE_CURRENCY, WRAPPED_ETHER } from '../constants'
import { Currency } from '../model'
import { useSettings } from '../providers'

function getPreferredCurrency(currency: Currency, useWeth: boolean) {
  if (useWeth) {
    return currency === NATIVE_CURRENCY[currency.chainId] ? WRAPPED_ETHER[currency.chainId] : currency
  } else {
    return currency === WRAPPED_ETHER[currency.chainId] ? NATIVE_CURRENCY[currency.chainId] : currency
  }
}

export function usePreferredCurrency(currency: Currency) {
  const { settings } = useSettings()

  const [state, setState] = useState<Currency>(getPreferredCurrency(currency, settings.useWeth))

  function setCurrency(currency: Currency) {
    setState(getPreferredCurrency(currency, settings.useWeth))
  }

  useEffect(() => {
    setCurrency(state)
  }, [settings])

  return [state, setCurrency] as const
}
